import React, { useMemo } from 'react';
import { decode } from 'jsonwebtoken';
import MgmActivity from '../components/MgmActivity';
import useAuth from '../../preorder/hooks/useAuth';
import { useAuthState } from '../../preorder/plugins/Auth';
import config from '../../preorder/configs/config';
import { mgmShareLink } from '../api/activity';

export default ({ data }) => {
  const [checkAuthenticated] = useAuth();
  const { campaignName } = data || {};
  const { iniviteMessage, backgroundUrl: dataBackgroundUrl } = data;
  const { token } = useAuthState();
  const backgroundUrl = `${config.RESOURCE_URI}${dataBackgroundUrl}`;

  const iniviteUrl = useMemo(() => {
    try {
      const { customerId } = decode(token);
      const { origin } = window.location;
      return `${origin}/register/mgm?referrerCustomerId=${customerId}&mgmCampaign=${campaignName}`;
    } catch (e) {
      // ignore the error
      return '';
    }
  }, [token, campaignName]);

  const onShareButtonClick = async () => {
    await mgmShareLink({ token, campaignName });
  };

  return (
    <MgmActivity
      data={data}
      iniviteMessage={iniviteMessage}
      iniviteUrl={iniviteUrl}
      isLogin={checkAuthenticated()}
      backgroundUrl={backgroundUrl}
      onShareButtonClick={onShareButtonClick}
    />
  );
};
